export const resetPasswordTypes = {
    RESET_PASSWORD_REQUEST: 'USER_RESET_PASSWORD_REQUEST',
    RESET_PASSWORD_SUCCESS: 'USER_RESET_PASSWORD_SUCCESS',
    RESET_PASSWORD_FAILURE: 'USER_RESET_PASSWORD_FAILURE',

    SET_ERROR: 'USER_RESET_PASSWORD_SET_ERROR',
    REMOVE_ERRORS: 'USER_RESET_PASSWORD_REMOVE_ERRORS',

    USER_RESET_PASSWORD_GENERAL_ERROR: "USER_RESET_PASSWORD_GENERAL_ERROR",
};
